export let CART_STATUS;
(function (CART_STATUS) {
  CART_STATUS["ABANDONED"] = "Abandoned";
  CART_STATUS["RECOVERED"] = "Recovered";
})(CART_STATUS || (CART_STATUS = {}));